import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
const VideoCard = (props) => {
  const ref = useRef();
  const peer = props.peer;

  console.log('video card');

  useEffect(() => {
    console.log('try peer');
    peer.on('stream', (stream) => {
      ref.current.srcObject = stream;
      console.log('here')
    });
    peer.on('track', (track, stream) => {
    });
  }, [peer]);

  return (
    <Video
      // playsInline
      ref={ref}
      autoPlay
      playInline
    ></Video>
  );
};

const Video = styled.video``;

export default VideoCard;
